import React, { useEffect, useMemo, useState } from 'react';
import { EuiFieldSearch, EuiFlexGroup, EuiFlexItem, EuiIcon, EuiLink } from "@elastic/eui";
import '../styles.css';

export const ValidacionExpatriadosSidebarScreen = (props:any) =>{
    
    const {data, onClick, selection, isLoading, translate} = props;

    const [search, setSearch] = useState('');

    const dataSearch = useMemo(()=>search!=='' ? data && data.filter((f: any) => new RegExp(`${search}.*`, "i").test(f["sociedad"])) : data,[search,data])

    const SelectFirst = ()=> (dataSearch && onClick(dataSearch[0]));
    
    useEffect(()=>{
        data && data.length>0 && onClick(data[0])
    },[data])

    useEffect(()=>{
        SelectFirst()
    },[dataSearch])

    

    const getItems = () =>{
        return dataSearch && dataSearch.map((soc:any,pos:number)=>{

            return (<EuiFlexItem grow={false}>
                    <EuiLink
                    className={`btn-list-validacion ${selection && soc.idSociedad===selection.idSociedad?'active':''}`}
                    onClick={() => {onClick(soc)}}
                    >
                    <EuiFlexGroup justifyContent='spaceAround' alignItems='center' gutterSize='s'>
                        <EuiFlexItem grow={false}><EuiIcon type={'visMapCoordinate'} size='m'/></EuiFlexItem>
                        <EuiFlexItem>{`${soc.sociedad}`}</EuiFlexItem>
                    </EuiFlexGroup>
                    </EuiLink>
            </EuiFlexItem>)
        })
    }

    // const loading = ()=>{
    //     return(
    //         <EuiSkeletonText
    //         lines={3}
    //         size={size}
    //         isLoading={isLoading}
    //         contentAriaLabel="Demo skeleton text"
    //     ></EuiSkeletonText>
    //     )
    // }

    return (
        <EuiFlexGroup direction='column' style={{height:'100%', overflow:'hidden'}}>
                <EuiFlexItem grow={false}>
                    <EuiFieldSearch fullWidth placeholder={`${translate('buscar')} ${translate('sociedad')} ...`} value={search} isClearable onChange={(e)=> setSearch(e.target.value)}/>
                </EuiFlexItem>
                <EuiFlexItem style={{height:'100%',overflowY:'auto',overflowX:'hidden', margin:'1rem'}} >
                <EuiFlexGroup direction='column' gutterSize='s' style={{margin:0}}>
                    {getItems()}
                </EuiFlexGroup>
                </EuiFlexItem>
        </EuiFlexGroup>
    )
}